import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SWRConfig } from 'swr'
import { TooltipProvider } from '@/components/ui/tooltip'
import App from './App'
import './index.css'

const swrConfig = {
  refreshInterval: 60000,      // Refresh every 60s
  dedupingInterval: 30000,     // Dedupe within 30s
  revalidateOnFocus: true,     // Refresh on tab focus
  errorRetryCount: 3,
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SWRConfig value={swrConfig}>
      <TooltipProvider delayDuration={300}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TooltipProvider>
    </SWRConfig>
  </React.StrictMode>,
)
